import React from "react";
import "../components/propertydetails/PropertyDetails.css";

export default function VideoModal({open, onClose, videoUrl}) {
    if (!open) return null;

    return (
        <div
            className="video-modal-overlay"
            role="dialog"
            aria-modal="true"
            onClick={onClose}
        >
            <div
                className="video-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="modal-close"
                    onClick={onClose}
                    aria-label="Close video"
                >
                    ✕
                </button>

                <video
                    className="video-player"
                    src={videoUrl}
                    controls
                    autoPlay
                    preload="none"
                >
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    );
}
